import { Button, CircularProgress } from '@mui/material';
import React, { useEffect } from 'react';

import { getPortalRuntimeConfig } from '../../../services/runtimeConfig';

export default function FinishLogin() {
  const redirectToApp = () => {
    const params = localStorage.getItem('login_hard_redirect');

    if (params) {
      const url = `onestep-${getPortalRuntimeConfig().env}://open/otp?${params}`;

      localStorage.removeItem('login_hard_redirect');
      window.location.replace(url);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      redirectToApp();
    }, 20 * 1000);
  }, []);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: '1',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px',
        gap: '20px',
      }}
    >
      <CircularProgress />
      <h5 className="text-2xl font-bold text-center">
        Taking you to the OneStep clinician app
      </h5>
      <Button variant="contained" onClick={redirectToApp} color="primary">
        Continue to App
      </Button>
    </div>
  );
}
